import React, { useState, useRef, useEffect } from 'react';
import {
  Button, Form, Row, Col,
} from 'react-bootstrap';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import useAPI from '../../hooks/useAPI';

export default function EditEvent(props) {
  const [content, setContent] = useState('');
  const [type, setType] = useState('event')
  const [eventDate, setEventDate] = useState(moment().format('yyyy-MM-DD'));

  useEffect(() => {
    setContent(props.event?.descr)
    setType(props.event?.type || 'event')
    setEventDate(moment(props.event?.date).format('yyyy-MM-DD'))
  }, [props.event]);

  return (
    <Modal {...props} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Редактирование события</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="mb-4">
            <Form.Group>
              <Form.Label className="d-flex justify-content-between">
                Описание
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={content}
                onChange={(e) => setContent(e.target.value)}
              />
            </Form.Group>
          </Row>
          <Row className='mb-4'>
            <Form.Group>
              <Form.Label>Тип события</Form.Label>
              <div className='d-flex gap-4'>
                <Form.Check
                  type='radio'
                  label='Мероприятия и ключевые события'
                  name='event-type'
                  value='event'
                  checked={type === 'event'}
                  onChange={(e) => setType(e.target.value)}
                />
                <Form.Check
                  type='radio'
                  label='Соглашения и отчетность'
                  name='event-type'
                  value='report'
                  checked={type === 'report'}
                  onChange={(e) => setType(e.target.value)}
                />
              </div>
            </Form.Group>
          </Row>
          <Row className="mb-4">
            <Form.Group as={Col} md="4">
              <Form.Label>Дата</Form.Label>
              <Form.Control
                type="date"
                onChange={(e) => setEventDate(e.target.value)}
                value={eventDate}
              />
            </Form.Group>
          </Row>
        </Form>
        <div>
          <Button onClick={() => {
            props.onSubmit({
              descr: content,
              eventDate,
              type
            })
            props.onHide();
          }}>Сохранить</Button>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide} variant="outline-secondary">
          Закрыть
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
